/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 인풋박스 컴포넌트
 * 버전 : 1.0
 * 파일명 : InputBoxOnChange.ts
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2025-07-17, 강동형 : 저작권 추가, 포커스 색 조정
 * ================================================================ 
 */

import React from "react";
import styled from "styled-components";

const Container = styled.input<{ $isValid?: boolean, $disabled? :boolean, $height? : string, $padding?:string, $fontSize?: string}>`
  border-radius : 5px;
  border: 1px solid 
  ${({ $isValid, $disabled }) =>
      $disabled
        ? "#DDDDDD" // ✅ disabled일 때 border
        : $isValid === undefined || $isValid === null
        ? "#ccc"
        : $isValid
        ? "#ccc"
        : "#FF5A5A"};
  font-size: ${({ $fontSize }) => $fontSize ?? '16px'};
  width: 100%;
  display: block;
  flex-grow: 1;
  padding: ${({ $padding }) => $padding ?? '10px 20px'};
  box-sizing: border-box;
  background-color: ${({ $disabled })=> $disabled ? '#F5F5F5': 'white'};
  height: ${({ $height }) => $height ?? 'auto'};
  &:focus{
    outline: none;
    border: 1px solid ${({ $isValid }) => $isValid === false ? '#FF5A5A' : '#39B95B'} !important;
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
  width: 100%;
`

interface Props {
  type? :string;
  defaultValue?: string; 
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isValid? : boolean;
  pattern? : string;
  title? : string;
  value? : any;
  disabled? : boolean;
  onFocus? : any;
  onBlur? : any
  height? : string
  padding? : string
  fontSize? : string
  maxLength? : number
}

const InputBoxOnChange = ({ placeholder, defaultValue, type, onChange , isValid, pattern, title, value, disabled, onFocus, onBlur, height, padding, fontSize, maxLength }: Props) => {

  return (
    <Wrapper>
    <Container
      type={type}
      placeholder={placeholder}
      defaultValue={defaultValue}
      onChange={onChange}
      pattern={pattern}
      title={title}
      $isValid={isValid}
      value={value}
      $disabled={disabled}
      disabled={disabled}
      onFocus={onFocus}
      onBlur={onBlur}
      $height={height}
      $padding = {padding}
      $fontSize = {fontSize}
      maxLength ={maxLength}
    />
    </Wrapper>
  );
};

export default InputBoxOnChange;
